<div class="action-container" [hidden]="hidden">
  <i class="icon ic-md ic-eye" (click)="onOpen()"></i>
</div>
